// extracted by mini-css-extract-plugin
export default {"zoomControls":"wca-z","zoomControlButton":"xca-z","zoomBanner":"yca-z","bannerButton":"zca-z","imageButton":"Aca-z","zoom":"Bca-z","zoomContent":"Cca-z"};